import * as z from 'zod';
/**
 * Supported application locales.
 *
 * Turkish is the default and English is the fallback. A key missing from `tr`
 * is a defect, not an opportunity to fall back.
 */
export const localeSchema = z.enum(['tr', 'en']);
export const DEFAULT_LOCALE = 'tr';
export const FALLBACK_LOCALE = 'en';
//# sourceMappingURL=locale.js.map